export default function CatalystSkeleton() {
  return (
    <div className="rounded-xl border border-neutral-200 bg-document p-4 animate-skeleton">
      <div className="mb-2 h-4 w-3/4 rounded bg-neutral-200" />
      <div className="mb-1 h-3 w-full rounded bg-neutral-200/70" />
      <div className="mb-3 h-3 w-2/3 rounded bg-neutral-200/70" />
      <div className="h-3 w-1/3 rounded bg-neutral-200/50" />
    </div>
  );
}
